import { z } from 'zod'

export const landingLeadFormSchema = z.object({
  company: z.string().trim().max(120, 'Keep the company or project under 120 characters.'),
  email: z.string().trim().email('Use a real email address.').max(160, 'Keep the email under 160 characters.'),
  message: z
    .string()
    .trim()
    .min(20, 'Give me a little more to work with.')
    .max(2_000, 'Keep the message under 2000 characters.'),
  name: z.string().trim().min(2, 'Tell me your name.').max(80, 'Keep the name under 80 characters.'),
})

export type LandingLeadFormValues = z.infer<typeof landingLeadFormSchema>

export function getDefaultLandingLeadFormValues(): LandingLeadFormValues {
  return {
    company: '',
    email: '',
    message: '',
    name: '',
  }
}
